import type Module from 'mini-common-schema/lib/schema/Module';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import type {
    SettingsSubRoutes,
    SettingsCategoryOption,
} from 'mini-common-schema/lib/schema/SettingsSubRoutes';

const MAIL_COMPOSE_REGEX = /\/mail\/.*compose/gi;
const MAIL_ACTIVITY_REGEX = /\/mail\/.*activity/gi;
/**
 * Adding an extra settingsCategoryOption as a stop gap to support the new advertising sub route option
 * Not investing much to clean this up as we will be migrating to react-router
 * @param params
 */
export default function optionsModuleRouterHandler(params: {
    subRoute?: SettingsSubRoutes;
    subRouteOption?: SettingsCategoryOption;
}) {
    switchModule(5, params.subRoute, params.subRouteOption);
}

/**
 * This cleanup activity has to be done especially when route handling
 * multiple module switches eg: MailModule to SettingsModule and then back to MailModule
 * USQ case: On clicking from Mail Compose, settings have to be opened
 * Nested routes, have to be handled in multiple cases over here.
 * @param params
 */
export const optionsModuleExitHandler = async () => {
    if (
        window.location.pathname.match(MAIL_COMPOSE_REGEX) ||
        window.location.pathname.match(MAIL_ACTIVITY_REGEX)
    ) {
        switchModule(0);
    }
    return false;
};
